export const appendQueryParams = (url: string, params: Record<string, string>): string => {
  const separator = url.includes("?") ? "&" : "?";
  const queryString = Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

  return `${url}${separator}${queryString}`;
};
